import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";
import { WebUrlRecord } from "../interface";

export const getWebUrls = async (
    tenantName: string,
    email: string,
    page: number = 1,
    limit: number = 15,
    search?: string
): Promise<WebUrlRecord[]> => {
    const params = new URLSearchParams({
        tenantName,
        email,
        page: String(page),
        limit: String(limit),
    });
    if (search?.trim()) {
        params.append("search", search.trim());
    }
    const url = `${NGROK}/api/websites/getAllAuth?${params.toString()}`;
    const data = await apiClient({
        method: "GET",
        url,
    });

    return data || [];
};

export const getWebUrlsCount = async (
    tenantName: string,
    email: string,
    search?: string
): Promise<number> => {
    const params = new URLSearchParams({
        tenantName,
        email,
    });
    if (search?.trim()) {
        params.append("search", search.trim());
    }
    const url = `${NGROK}/api/websites/getAllAuth/count?${params.toString()}`;
    const data = await apiClient({
        method: "GET",
        url,
    });

    return typeof data === "number" ? data : 0;
};

export const publishURL = async (tenantName: string, urlId: number, selectedRoles: string[]) => {

    const url = `${NGROK}/api/websites/publish?tenantName=${tenantName}&webID=${urlId}&rolesList=${selectedRoles.join(",")}`;
    const data = await apiClient({
        method: "PUT",
        url,
    });

    return data || [];
};


export const updateRecording = async (tenantName: string, urlId: number) => {
    const url = `${NGROK}/api/websites/updateRecording?tenantName=${tenantName}&webId=${urlId}`;
    const data = await apiClient({
        method: "PUT",
        url,
    });

    return data || [];
};

export const createAuth = async (payload: any) => {
    const url = `${NGROK}/api/websites/createAuth`;
    const data = await apiClient({
        method: "POST",
        url,
        data: payload
    });

    return data || [];
};

export const updateAuth = async (payload: any, tenantName: string) => {
    const url = `${NGROK}/api/websites/updateAuth?tenantName=${tenantName}`;
    const data = await apiClient({
        method: "PUT",
        url,
        data: payload
    });

    return data || [];
};


export const fetchAllRecording = async (urlId: string, tenantName: string) => {
    const url = `${NGROK}/api/websites/${tenantName}/list-all-files-in-zips?webId=${urlId}`;
    const data = await apiClient({
        method: "GET",
        url
    });

    return data || [];
};



export const deleteURL = async (urlId: number) => {
    const url = `${NGROK}/api/websites/deleteAuth/${urlId}`;
    const data = await apiClient({
        method: "DELETE",
        url
    });

    return data || [];
};
